module.exports = __webpack_public_path__ + "img/slider-3.8070299c.png";